import { env, IEnvironment } from "@/env";

interface IAppState {
    lang: string;
    env: IEnvironment;
    now: Date;
    loaded: boolean;
    sasToken: string;
}

const initialState: IAppState = {
    lang: "fr",
    env,
    now: new Date(),
    loaded: false,
    sasToken: "",
};

export { IAppState, initialState };
